// extracted by mini-css-extract-plugin
export var Box = "ItemDescription-module--Box--b3709";